// user-dashboard/components/DetailsModal.jsx
import React from "react";
import { TM_REQUEST_REASON_LABELS, isUseSameDetails } from "../../../shared/tmAccountRequest";
import StaffAddTmEmailForm from "./StaffAddTmEmailForm";

/**
 * Modal for showing extra details (address, DOB, etc.)
 *
 * Props:
 * - open (boolean): whether the modal is open
 * - onClose (function): callback to close the modal
 * - record (object): the current advice/email record
 * - profile (object): user profile containing address / DOB info
 */
export default function DetailsModal({
  open,
  onClose,
  record,
  profile,
  tmRequest = null,
  isStaff = false,
  onNewEmailCreated = null,
}) {
  if (!open) return null;

  const stop = (e) => e.stopPropagation();
  const request = tmRequest || record?.tmAccountRequest || null;
  const reasonLabel = request
    ? TM_REQUEST_REASON_LABELS[request.reason] || request.reason || "—"
    : null;
  const requestedAt = request?.created_at
    ? new Date(request.created_at).toLocaleString()
    : "—";

  const address =
    profile?.email_specific_address ||
    record?.email_specific_address ||
    record?.address ||
    "";

  const dob =
    profile?.email_specific_dob ||
    record?.email_specific_dob ||
    record?.DOB ||
    record?.dob ||
    "—";

  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      onClick={onClose}
    >
      <div className="modal-dialog modal-dialog-scrollable" onClick={stop}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Details</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="mb-2">
              <strong>Site:</strong> {record?.site || "—"}
            </div>
            <div className="mb-2">
              <strong>Email:</strong> {record?.email || "—"}
            </div>
            <div className="mb-2">
              <strong>Date of Birth:</strong> {dob || "—"}
            </div>
            <div className="mb-2">
              <strong>Address:</strong>
              <div className="text-muted" style={{ whiteSpace: "pre-wrap" }}>
                {address || "—"}
              </div>
            </div>
            {request && (
              <>
                <hr />
                <div className="fw-semibold mb-2">New TM Account Request</div>
                {isStaff ? (
                  <div className="mb-2">
                    <strong>User code:</strong> {request.user_code || record?.user_code || "—"}
                  </div>
                ) : null}
                <div className="mb-2">
                  <strong>Reason:</strong> {reasonLabel}
                </div>
                {request.other_reason ? (
                  <div className="mb-2">
                    <strong>Other reason:</strong>
                    <div className="text-muted" style={{ whiteSpace: "pre-wrap" }}>
                      {request.other_reason}
                    </div>
                  </div>
                ) : null}
                {isStaff && (request.replace_proxy || request.reason === "map_issue") ? (
                  <div className="mb-2">
                    <strong>Proxy:</strong> We also need to replace the proxy for this account.
                  </div>
                ) : null}
                <div className="mb-2">
                  <strong>Account details:</strong>{" "}
                  {isUseSameDetails(request)
                    ? "Use the same details as existing"
                    : "Do not use the same details as existing"}
                </div>
                <div className="mb-2">
                  <strong>TT OTP number(s):</strong> {request.assigned_numbers || "—"}
                </div>
                <div className="mb-2">
                  <strong>Requested by:</strong> {request.requested_by || "—"}
                </div>
                <div className="mb-2">
                  <strong>Requested at:</strong> {requestedAt}
                </div>
                <div className="mb-0">
                  <strong>Status:</strong> {request.status || "pending"}
                </div>
                {isStaff && (request.status || "pending") === "pending" && (
                  <StaffAddTmEmailForm
                    record={record}
                    request={request}
                    onCreated={onNewEmailCreated}
                  />
                )}
              </>
            )}
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-secondary btn-sm"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
